import { ApiService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';

import { Component, Input } from '@angular/core';
import { SuscriptionService } from '@core/services';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-subscription-stop-selection',
  templateUrl: './subscription-stop-selection.component.html',
  styleUrls: ['./subscription-stop-selection.component.scss'],
})
export class SubscriptionStopSelectionComponent {
  @Input() dotw = null;
  @Input() lockedZone = null;
  @Input() lockedRoute = null;
  @Input() type = 'go';
  zones;
  zone;
  routes;
  route;
  stops;
  subscription;
  stops2 = [
    {
      id: 1,
      name: 'Av. de las granjas y camarones (en el oxxo)',
      image: 'https://ui-avatars.com/api/?background=0D8ABC&color=fff&name=1',
    },
    {
      id: 2,
      name: 'Av. de las granjas, esq. Rabaul (oxxo)',
      image: 'https://ui-avatars.com/api/?background=0D8ABC&color=fff&name=2',
    },
    {
      id: 3,
      name: 'Av. de las granjas esquina Calz. Azcapotzalco',
      image: 'https://ui-avatars.com/api/?background=0D8ABC&color=fff&name=3',
    },
    {
      id: 4,
      name: 'Eje 5 norte y San Pablo',
      image: 'https://ui-avatars.com/api/?background=0D8ABC&color=fff&name=4',
    },
  ];
  stop;

  searchTerm = '';

  filteredStops = []; // Store filtered data
  loading: boolean;

  constructor(
    private modalController: ModalController,
    private apiService: ApiService,
    private authService: AuthService,
    private suscriptionService: SuscriptionService
  ) {}

  ionViewDidEnter() {
    this.stops = null;
    this.filteredStops = this.stops;
    this.getSuscription();
  }

  getSuscription() {
    this.authService.get('suscription').then((res) => {
      console.log('Suscription: ', res);
      if (res.data) {
        this.subscription = res.data;
        this.zone = { id: res.data.zone_id, name: res.data.zone_name };
        if (this.zone && res.data.name.toLowerCase().indexOf('f') === 0) {
          this.zones = [this.zone];
          this.getRoutes();
        } else {
          this.getZones();
        }
      }
    });
  }

  getZones() {
    this.apiService.getData('zones?subscription=1').then((res) => {
      console.log('zones: ', res);
      this.zones = res.data;
      this.selectZoneById();
    });
  }

  getRoutes() {
    const zone = this.zone ? '&zone=' + this.zone.id : '';
    const dotw = this.dotw ? '&dotw=' + this.dotw : '';
    this.apiService
      .getData('transportec-routes?type=' + this.type + dotw + zone)
      .then((res) => {
        console.log('routes: ', res);
        this.routes = res.data;
        this.selectRouteById();
      })
      .finally(() => {});
  }

  getStops() {
    const isExtraRegistrationOpen = this.suscriptionService.isExtraRegistrationOpen();
    const isResetSuscribable = this.suscriptionService.isResetSuscribable();
    const subscriptionFlag = isExtraRegistrationOpen || isResetSuscribable ? '&subscription=true' : '';
    this.loading = true;
    this.apiService
      .getData('transportec-stops?route=' + this.route.id + subscriptionFlag)
      .then((res) => {
        console.log('stops: ', res.data);
        this.stops = res.data;
        this.filteredStops = this.stops;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  selectZone(selected) {
    if (selected) {
      this.zone = selected;
      this.stops = null;
      this.routes = null;
      this.filteredStops = null;
      this.getRoutes();
    }
    console.log('zone: ', this.zone);
  }

  selectZoneById() {
    if (this.lockedZone) {
      console.log('select Zone by id: ', this.lockedZone);
      const zone = this.zones.filter((x) => {
        return x.id === this.lockedZone;
      })[0];
      this.selectZone(zone);
    }
  }

  selectRouteById() {
    if (this.lockedRoute) {
      console.log('select Route by id: ', this.lockedRoute);
      const route = this.routes.filter((x) => {
        return x.id === this.lockedRoute;
      })[0];
      this.selectRoute(route);
    }
  }

  zoneCompare(a: { id: number }, b: { id: number }) {
    if (a && b && a.id === b.id) {
      return true;
    }
    return false;
  }

  selectRoute(selected) {
    if (selected) {
      this.route = selected;
      this.stops = null;
      this.filteredStops = null;
      this.getStops();
    }
    console.log(this.route);
  }

  routeCompare(a, b) {
    if (a && b && a === b) {
      return true;
    }
    return false;
  }

  setFilteredStops() {
    this.filteredStops = this.stops.filter((stop) => {
      return stop.name.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1;
    });
  }

  closeModal() {
    this.modalController.dismiss();
  }

  select(selectedStop) {
    this.modalController.dismiss({
      stop: selectedStop,
    });
  }
}
